/**
 * Una foto de propuesta: `url` es siempre el archivo original subido;
 * `url_ficha` (opcional) es un recorte JPEG para mostrar en ficha/catálogo.
 */
export type PropuestaFotoItem = {
  url: string;
  id: string;
  url_ficha?: string;
};

/** URL para mostrar en UI (ficha, listas, votación): recorte si existe, si no el original. */
export function urlFotoMostrar(foto: { url: string; url_ficha?: string | null }): string {
  const ficha = foto.url_ficha != null ? String(foto.url_ficha).trim() : '';
  return ficha || foto.url;
}

/** URL del archivo original (p. ej. descarga). */
export function urlFotoOriginalDescarga(foto: { url: string }): string {
  return foto.url;
}
